import { Client } from '@microsoft/microsoft-graph-client';
import {
  type IPublicClientApplication,
  type AccountInfo,
  InteractionRequiredAuthError,
} from '@azure/msal-browser';

let cachedClient: Client | null = null;
let cachedAccount: string | null = null;

export function getGraphClient(
  msalInstance: IPublicClientApplication,
  account: AccountInfo,
): Client {
  // Reuse client if same account
  if (cachedClient && cachedAccount === account.homeAccountId) {
    return cachedClient;
  }

  cachedClient = Client.init({
    authProvider: async (done) => {
      try {
        const response = await msalInstance.acquireTokenSilent({
          scopes: [
            'User.Read',
            'User.Read.All',
            'Directory.Read.All',
            'Organization.Read.All',
            'Sites.ReadWrite.All',
            'Mail.Send',
            'Files.ReadWrite.All',
          ],
          account,
        });
        done(null, response.accessToken);
      } catch (error) {
        if (error instanceof InteractionRequiredAuthError) {
          try {
            const response = await msalInstance.acquireTokenPopup({
              scopes: [
                'User.Read',
                'User.Read.All',
                'Directory.Read.All',
                'Organization.Read.All',
                'Sites.ReadWrite.All',
                'Mail.Send',
                'Files.ReadWrite.All',
              ],
              account,
            });
            done(null, response.accessToken);
          } catch (popupError) {
            done(popupError as Error, null);
          }
        } else {
          done(error as Error, null);
        }
      }
    },
  });

  cachedAccount = account.homeAccountId;
  return cachedClient;
}
